<div *ngIf="attachments?.length>0|| newAttachments?.length>0" class="container">
  <div class="attachment" *ngFor="let attachment of attachments">
    <ng-container *ngIf="!!attachment">
      <div class="zoom" (click)="attachmentClicked(attachment)">
        <mat-icon>zoom_out_map</mat-icon>
      </div>
      <mat-card class="attachment-list-card">
        <mat-card-title>{{attachment.createdAt | date: 'MM/dd/yyyy h:mm:ss a'}}</mat-card-title>
        <mat-card-content>
          <div *ngIf="isImage(attachment) ">
            <img mat-card-image [src]="attachment.downloadUrl | authImage | async | safeUrl ">
          </div>
          <div *ngIf="!isImage(attachment) ">
            <img mat-card-image src="assets/imgs/icons8-document.svg">
          </div>
        </mat-card-content>
      </mat-card>
    </ng-container>
  </div>
  <div class="attachment" *ngFor="let newAttachment of newAttachments">
    <ng-container *ngIf="!!newAttachment">
      <div class="zoom" (click)="attachmentClicked(newAttachment)">
        <mat-icon>zoom_out_map</mat-icon>
      </div>
      <mat-card class="attachment-list-card">
        <mat-card-title>New attachment</mat-card-title>
        <mat-card-content>
          <div *ngIf="isImage(newAttachment) ">
            <img mat-card-image [src]="newAttachment.downloadUrl | authImage | async | safeUrl ">
          </div>
          <div *ngIf="!isImage(newAttachment) ">
            <img mat-card-image src="assets/imgs/icons8-document.svg">
          </div>
        </mat-card-content>
      </mat-card>
    </ng-container>
  </div>
</div>
